module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Compiled-file-807de54a90ef356e550aed6ea8d67531.svg";